import Axios from 'axios'
import { SAFETY_URL, RESOLVER_URL, getErrorMessage } from '@/main'
import { showErrorToast } from '@/utils/toast'

const state = {
  stateSafetyResult: null,
  stateSafetyEndpoints: null,
  stateSafetyProfiles: null,
  safetyBuildDate: null,
  loading: false,
  errorMessage: null,
}

const getters = {
  safetyResult: (state) => {
    return state.stateSafetyResult
  },
  safetyEndpoints: (state) => {
    return state.stateSafetyEndpoints
  },
  safetyProfiles: (state) => {
    return state.stateSafetyProfiles
  },
  getSafetyLoading: (state) => state.loading,
  getSafetyErrorMessage: (state) => state.errorMessage,
}

const mutations = {
  setSafetyResult: (state, payload) => {
    state.stateSafetyResult = payload
  },
  resetSafetyResult: (state) => {
    state.stateSafetyResult = null
    state.loading = false
    state.errorMessage = null
  },
  setSafetyEndpoints: (state, payload) => {
    state.stateSafetyEndpoints = payload
  },
  setSafetyProfiles: (state, payload) => {
    state.stateSafetyProfiles = payload
  },
  SET_SAFETY_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_SAFETY_ERROR_MESSAGE: (state, payload) => {
    state.errorMessage = payload
  },
}

const actions = {}

export function prepareSafetyMetadata(context) {
  Axios.get(`${SAFETY_URL}/metadata`)
    .then((response) => {
      context.commit('setSafetyEndpoints', response.data.safetyEndpoints)
      context.commit('setSafetyProfiles', response.data.safetyProfiles)
      context.commit('setFeatures', { safety: { category: 'module' } })
    })
    .catch((error) => {
      console.warn('SAFETY module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { safety: {} })
    })
}

export function getFlags(chemicals, instance) {
  let pushReport = true
  if (!instance) {
    instance = this
  } else {
    pushReport = false
  }

  instance.$store.commit('SET_VIEW_STRUCTURES', false)
  instance.$store.commit('SET_SAFETY_LOADING', true)
  instance.$store.commit('SET_SAFETY_ERROR_MESSAGE', null)

  const request = chemicals.filter((chemical) => chemical.sid).map((c) => ({ sid: c.sid }))

  instance.$axios
    .post(`${RESOLVER_URL}/safety-flags`, request)
    .then((response1) => {
      return instance.$axios
        .post(
          `${SAFETY_URL}/rqcodes`,
          response1.data.flags.map((r) => r.chemical),
        )
        .then((response2) => {
          response1.data.flags.map((d1) => {
            let r2 = response2.data.find((d2) => d2.chemical.sid === d1.chemical.sid)
            d1.rqCode = r2.rqCode
            return d1
          })
          instance.$store.commit('setSafetyResult', response1.data)
          instance.$store.commit('SET_SAFETY_LOADING', false)
          if (pushReport) {
            instance.$router.push(`/safety/report`)
          }
        })
      // .catch((error) => {
      //   instance.$store.commit('SET_SAFETY_ERROR_MESSAGE', getErrorMessage(error))
      //   showErrorToast(error)
      //   instance.$store.commit('SET_SAFETY_LOADING', false)
      // })
    })
    .catch((error) => {
      instance.$store.commit('SET_SAFETY_ERROR_MESSAGE', getErrorMessage(error))
      showErrorToast(error)
      instance.$store.commit('SET_SAFETY_LOADING', false)
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
